import { queryOptions, skipToken } from '@tanstack/react-query';
import { apiQueryKeys } from '../apiQueryKeys';
import { getServiceQualification } from '../getServiceQualification';
import { MINUTE_IN_MS } from '@/utils/dates';
import type { AddressMatch } from '../addressSearch/schemas';

export const serviceQualificationQueryOptions = ({
  selectedAddress,
  isEnabled = true,
}: {
  selectedAddress: AddressMatch | null;
  isEnabled?: boolean;
}) => {
  const formattedAddress = selectedAddress?.formattedAddress || 'unknown';
  const providersKey =
    selectedAddress?.providers.map(
      (provider) => `${provider.name}-${provider.locationId}`
    ) || 'no-providers';

  return queryOptions({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      ...apiQueryKeys.serviceQualification,
      formattedAddress,
      ...providersKey,
    ],
    queryFn:
      selectedAddress && isEnabled
        ? () =>
            getServiceQualification({
              serviceProviders: selectedAddress.providers,
            })
        : skipToken,
    staleTime: MINUTE_IN_MS * 30,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
